import authLocalFe from '@blaze-cms/plugin-auth-local-fe';
import ecommerceComponents from '@blaze-cms/plugin-ecommerce-components';
import ecommerceStripe from '@blaze-cms/plugin-ecommerce-stripe-fe';
import examplePlugin from './blaze-plugins/example';
import halComponents from './blaze-plugins/hal-components';

export default function buildConfig(config) {
  // To set custom plugins into the project.
  config.plugins.set(examplePlugin, {});
  config.plugins.set(ecommerceStripe, {});
  config.plugins.set(halComponents, {});
  config.plugins.set(authLocalFe, {});
  config.plugins.set(ecommerceComponents, {});

  // eslint-disable-next-line no-param-reassign
  config.apollo = {
    ...config.apollo,
    disableUpload: true
  };
  return config;
}
